<input class="tgl tgl-{{ theme }}" [id]="id" type="checkbox" (change)="toggle()" [checked]="checked" />
<label class="tgl-btn tgl-btn-4" [for]="id"></label>
